import { tw, variants } from 'classname-variants';
import classNames from 'classnames';
import React from 'react';
import type { ReactNode } from 'react';

export const buttonAndLinkVariants = variants({
  variants: {
    variant: {
      primary: tw`text-p1 leading-none px-[1.5em] py-[0.51em] rounded-[0.25em] inline-block`,
      secondary: tw`inline-block underline text-p1 bg-transparent`,

      // Arrows
      'arrow-left': tw`relative inline-block rounded-full h-7 w-7 after:absolute after:h-full after:w-full after:top-0 after:left-0 after:bg-cover rotate-180`,

      'arrow-right': tw`relative inline-block rounded-full h-7 w-7 after:absolute after:h-full after:w-full after:top-0 after:left-0 after:bg-cover`,

      // Naked arrows
      'naked-arrow-left': tw`relative inline-block rounded-full h-7 w-7 after:absolute after:h-full after:w-full after:top-0 after:left-0 after:bg-cover rotate-180`,

      'naked-arrow-up': tw`relative inline-block rounded-full h-7 w-7 after:absolute after:h-full after:w-full after:top-0 after:left-0 after:bg-cover rotate-[270deg]`,

      'naked-arrow-down': tw`relative inline-block rounded-full h-7 w-7 after:absolute after:h-full after:w-full after:top-0 after:left-0 after:bg-cover rotate-90`,

      'naked-arrow-right': tw`relative inline-block rounded-full h-7 w-7 after:absolute after:h-full after:w-full after:top-0 after:left-0 after:bg-cover`,
    },
  },
});

export type ButtonProps = React.HTMLAttributes<HTMLButtonElement> & {
  type: 'button' | 'submit' | 'reset';
  variant:
  | 'primary'
  | 'secondary'
  | 'arrow-left'
  | 'arrow-right'
  | 'naked-arrow-left'
  | 'naked-arrow-up'
  | 'naked-arrow-down'
  | 'naked-arrow-right';
  className?: string;
  children?: ReactNode;
};

export const Button = ({
  type,
  variant,
  className,
  children,
  ...rest
}: ButtonProps) => {
  // if (!children || variant !== 'arrow-left' || 'arrow-right') {
  //   return null;
  // }

  return (
    // eslint-disable-next-line react/button-has-type
    <button
      type={type}
      className={classNames(
        buttonAndLinkVariants({ variant }),
        `ff-button--${variant}`,
        `overlayOverBkg`,
        className
      )}
      {...rest}
    >
      {children}
    </button>
  );
};
